import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { ManagedLighthouse } from '#dn-types/managed-lighthouse.ts';
import { makeMaxResourceQueryFn } from '#util/api.ts';
import { managedLighthouseQueryKeys, ManagedLighthouses } from './index.ts';

/**
 * Max-pages query options for the org's managed lighthouses. The list is bounded by the network
 * cap (one entry per network), so a single 500-item page fetches everything in practice —
 * consumers join entries to networks by `networkID` instead of fetching per network.
 */
export const maxManagedLighthousesQueryOptions = queryOptions({
  queryKey: managedLighthouseQueryKeys.maxList,
  queryFn: makeMaxResourceQueryFn(ManagedLighthouses.getManagedLighthouses),
});

/** The org's managed lighthouses, fetched once org-wide (all pages). */
export function useSuspenseManagedLighthouses(): ManagedLighthouse[] {
  return useSuspenseQuery(maxManagedLighthousesQueryOptions).data.data;
}
